// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"4f63a4e1","120":"cc2d2707","158":"25641b90","175":"f7c9bf60","178":"d0d8a8d4","367":"a8b9da8c","797":"db64e84c","917":"6bfe6ee3"}[chunkId] + ".chunk.js";
};